import React from "react";
import CustomPagination from "../customPagination";
const ListingFooter = ({ leftComponent = null, leftComponentClass = null, parentClass = "", paginationProps, }) => {
    return (React.createElement("div", { className: `fixed-footer-wrapper d-print-none ${parentClass}` },
        React.createElement("div", { className: "footer-container" },
            React.createElement("div", { className: leftComponentClass, style: { minWidth: "10%" } }, leftComponent),
            React.createElement(CustomPagination, Object.assign({}, paginationProps)))));
};
export default ListingFooter;
